import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alert-snackbar',
  templateUrl: './alert-snackbar.component.html',
  styleUrls: ['./alert-snackbar.component.scss']
})
export class AlertSnackbarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
